export const gradosColgio = [{
    id: 1,
    name: "3 Años",
    tipo: "1",
    value: 1,
},{
    id: 2,
    name: "4 Años",
    tipo: "1",
    value: 2
},{
    id: 3,
    name: "5 Años",
    tipo: "1",
    value: 3
},{
    id: 4,
    name: "1er Año",
    tipo: "2",
    value: 4
},{
    id: 5,
    name: "2do Año",
    tipo: "2",
    value: 5
},{
    id: 6,
    name: "3er Año",
    tipo: "2",
    value: 6
},{
    id: 7,
    name: "4to Año",
    tipo: "2",
    value: 7
},{
    id: 8,
    name: "5to Año",
    tipo: "2",
    value: 8
},{
    id: 9,
    name: "6to Año",
    tipo: "2",
    value: 9
},{
    id: 10,
    name: "1er Año",
    tipo: "3",
    value: 10
},{
    id: 11,
    name: "2do Año",
    tipo: "3",
    value: 11
},{
    id: 12,
    name: "3er Año",
    tipo: "3",
    value: 12
},{
    id: 13,
    name: "4to Año",
    tipo: "3",
    value: 13
},{
    id: 14,
    name: "5to Año",
    tipo: "3",
    value: 14
}]